export default (function() {
  let client = ['iPhone', 'Android', 'Windows Phone'],
      mSite = 'http://m.dianping.com',
      pathname = window.location.pathname,
      redictBool = false;
  for (let i = 0, agent;i < client.length; i++) {
      agent = client[i]
      if (navigator.userAgent.indexOf(agent) != -1) {
        redictBool = true;
        break
      } else { 
        redictBool = false
      }
  }

  function redictTo() {
      location.href = mSite + pathname
  }

  function addCookie() {
      if (document.referrer.indexOf(mSite) == 0) {
          document.cookie = 'vmod=pc;expires=0;'
      }
      return document.cookie.match(/vmod=pc/)
  }

  if (redictBool) {
      if (!addCookie()) {
        redictTo()
      }
  }
})();


// WEBPACK FOOTER //
// ./src/lib/servlet.js